import { LecBankAccount } from '../../lib/types/models/lec-bank-account/lec-bank-account'
import { LecBankAccountInput } from '../../lib/types/models/lec-bank-account/lec-bank-account-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateLecBankAccount(id: number, data: Partial<LecBankAccountInput>) {
  return restApiClient
    .url(constructApiUrl(API.lecBankAccounts.update.url, { id }))
    .patch<LecBankAccount, Partial<LecBankAccountInput>>(data)
}
